import { HomeLink } from "./HomeLink";
import { HomeWrap } from "./HomeWrap";
import mascot from "@/assets/mascot-normal-64.png";

export function HomeHeader() {
  return (
    <header className="border-b border-[#E2D5C0] bg-[#FAF8F5]">
      <HomeWrap className="flex items-center justify-between gap-6 py-4 max-[400px]:gap-3">
        <HomeLink to="/" className="flex shrink-0 items-center gap-[9px] no-underline">
          <img src={mascot} alt="" aria-hidden="true" width={64} height={83} className="w-7 object-contain" />
          <span className="font-display text-2xl font-semibold max-[359px]:text-xl tracking-[-0.02em] text-[#3B2314]">
            grounded
          </span>
        </HomeLink>
        <nav className="flex items-center gap-6 text-[15px] max-[400px]:gap-3">
          <a href="#score" className="hidden text-[#7B4F2E] no-underline min-[761px]:inline">
            The score
          </a>
          <a href="#cities" className="hidden text-[#7B4F2E] no-underline min-[761px]:inline">
            Cities
          </a>
          <HomeLink to="/browse" className="whitespace-nowrap text-[#7B4F2E] no-underline">
            Browse cafés
          </HomeLink>
          <HomeLink
            to="/auth"
            className="relative inline-flex items-center whitespace-nowrap rounded-full border-[1.5px] border-[#3B2314] bg-transparent px-4 py-1.5 font-medium text-[#3B2314] no-underline transition-colors hover:bg-[#3B2314] hover:text-[#FAF8F5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#7B4F2E] focus-visible:ring-offset-2 focus-visible:ring-offset-[#FAF8F5] before:absolute before:inset-x-0 before:-inset-y-2 before:content-[''] max-[400px]:px-3"
          >
            Log in
          </HomeLink>
        </nav>
      </HomeWrap>
    </header>
  );
}
